import { api } from '@/lib/trpc/react';
import { useWorkspaceActions } from './useWorkspace';

export const useUpdateGroupCollapsed = () => {
  const { updateChatbot } = useWorkspaceActions();

  const { mutate: groupCollapsedMutate } =
    api.sidebar.updateGroupCollapsed.useMutation({
      onMutate: async ({ id, collapsed }) => {
        // Cancel any outgoing refetches

        // Optimistically update the UI

        updateChatbot(id, { groupCollapsed: collapsed });

        return { prevData: { id, collapsed } };
      },

      onError: (err, _, context) => {
        // If error, roll back to previous state
        if (context?.prevData) {
          updateChatbot(context.prevData.id, {
            groupCollapsed: !context.prevData.collapsed,
          });
        }
        console.error('Error updating group collapsed state:', err);
      },
    });

  return { groupCollapsedMutate };
};
